// @flow
import { connect } from 'react-redux';
import PromotionCodeButtonWithModal from './PromotionCodeButtonWithModal';
import { setPromotionCodeModalVisible } from '../../../../../modules/SignUp/Bonus/actions';
import { isPromotionCodeModalVisibleSelector } from '../../../../../modules/SignUp/Bonus/reducer';

const mapStateToProps = state => ({
  isModalVisible: isPromotionCodeModalVisibleSelector(state),
});

const mapDispatchToProps = {
  setPromotionCodeModalVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionCodeButtonWithModal);
